import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api/api";
import { KONTAKT } from "../config/kontakt";

const KEY = "ausbildungjob_content";
const DEF = {
  intro: "Wir sind ein familiengeführter Milchhof in der Region Sisbeck. Wenn Sie Teil unseres Teams werden möchten oder eine Ausbildung im landwirtschaftlichen Bereich anstreben – melden Sie sich gerne bei uns.",
  k1titel: "Ausbildung",          k1text: "Interesse an einer Ausbildung als Landwirt/in oder in verwandten Berufen? Sprechen Sie uns direkt an – wir freuen uns über motivierte Nachwuchskräfte.",
  k2titel: "Fahrer / Lieferung",  k2text: "Für unsere täglichen Milchlieferungen suchen wir zuverlässige Fahrer in der Region. Flexible Arbeitszeiten, früher Start.",
  k3titel: "Hofarbeit & Sonstiges", k3text: "Je nach Saison und Bedarf suchen wir auch Unterstützung auf dem Hof. Einfach melden – wir schauen gemeinsam, was passt.",
};
const KARTEN = [["k1", "🎓"], ["k2", "🚚"], ["k3", "🌾"]];

function mitLinks(text) {
  const teile = text.split(/(https?:\/\/[^\s]+)/g);
  return teile.map((teil, i) =>
    teil.startsWith("http")
      ? <a key={i} href={teil} target="_blank" rel="noopener noreferrer" style={{ color: "#2e7d32", wordBreak: "break-all" }}>{teil}</a>
      : teil
  );
}

export default function AusbildungJob() {
  const { user } = useAuth();
  const isAdmin = !!user?.isAdmin;
  const [content, setContent] = useState(DEF);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(DEF);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.einstellungen.get(KEY).then(r => { if (r) setContent(JSON.parse(r)); }).catch(() => {});
  }, []);

  async function save() {
    try {
      await api.einstellungen.update(KEY, JSON.stringify(draft));
      setContent(draft);
      setEditing(false);
      setMsg("✓ Gespeichert!");
      setTimeout(() => setMsg(null), 3000);
    } catch { setMsg("Fehler beim Speichern."); }
  }

  const set = k => e => setDraft(d => ({ ...d, [k]: e.target.value }));
  const c = editing ? draft : content;

  return (
    <div className="container">
      <h2 className="section-title">👷 Ausbildung & Job</h2>
      {msg && <p style={{ color: msg.startsWith("✓") ? "green" : "red", marginBottom: "0.5rem" }}>{msg}</p>}

      {editing
        ? <textarea rows={3} value={draft.intro} onChange={set("intro")} style={TA} />
        : <p style={{ color: "#555", marginBottom: "2rem", fontSize: "1.05rem" }}>{c.intro}</p>
      }

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "1.5rem", marginBottom: "2.5rem" }}>
        {KARTEN.map(([k, icon]) => (
          <div key={k} className="card" style={{ border: "1.5px solid #a5d6a7" }}>
            <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>{icon}</div>
            {editing ? (
              <>
                <input value={draft[k + "titel"]} onChange={set(k + "titel")} style={IN} />
                <textarea rows={3} value={draft[k + "text"]} onChange={set(k + "text")} style={TA} />
              </>
            ) : (
              <>
                <h3>{c[k + "titel"]}</h3>
                <p style={{ color: "#666", fontSize: "0.9rem" }}>{mitLinks(c[k + "text"])}</p>
              </>
            )}
          </div>
        ))}
      </div>

      {isAdmin && !editing && (
        <button className="btn btn-secondary" style={{ marginBottom: "1.5rem" }}
          onClick={() => { setDraft(content); setEditing(true); setMsg(null); }}>
          ✏️ Seite bearbeiten
        </button>
      )}
      {editing && (
        <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1.5rem" }}>
          <button className="btn btn-primary" onClick={save}>Speichern</button>
          <button className="btn btn-secondary" onClick={() => setEditing(false)}>Abbrechen</button>
        </div>
      )}

      <div style={{ background: "linear-gradient(135deg, #e8f5e9, #c8e6c9)", borderRadius: "16px", padding: "2rem", border: "2.5px solid #66bb6a" }}>
        <h3 style={{ color: "#1b5e20", marginBottom: "1rem" }}>📬 Bewerben Sie sich</h3>
        <p style={{ color: "#388e3c", marginBottom: "1.25rem" }}>Schreiben Sie uns eine E-Mail mit einer kurzen Vorstellung oder rufen Sie uns in den Bürozeiten an.</p>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
          <div><strong>📱 Telefon:</strong> <a href={`tel:${KONTAKT.telefon}`} style={{ color: "#2e7d32" }}>{KONTAKT.telefon}</a></div>
          <div><strong>✉️ E-Mail:</strong> <a href={`mailto:${KONTAKT.email}`} style={{ color: "#2e7d32" }}>{KONTAKT.email}</a></div>
          <div style={{ fontSize: "0.9rem", color: "#555", marginTop: "0.25rem" }}>🏢 Bürozeiten: Mo – Fr, 07:30 – 11:30 Uhr</div>
        </div>
      </div>
    </div>
  );
}

const TA = { width: "100%", padding: "0.4rem", borderRadius: 5, border: "1px solid #ccc", fontSize: "0.9rem", marginBottom: "0.25rem", resize: "vertical", fontFamily: "inherit" };
const IN = { width: "100%", padding: "0.4rem", borderRadius: 5, border: "1px solid #ccc", fontSize: "1rem", marginBottom: "0.25rem", fontFamily: "inherit", fontWeight: 600 };
